import { FocusEventHandler, ReactElement } from "react";
import { Control, Controller, FieldErrors, FieldValues } from "react-hook-form";

import { Input } from "@ui/FormElements";

interface Props {
  control: Control<FieldValues> | any;
  name: string;
  label: string;
  StartIcon?: ReactElement;
  disabled?: boolean;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  errors: FieldErrors<any>;
  inputRef?: React.Ref<HTMLInputElement>;
}

export function ControlledInput({
  control,
  name,
  label,
  StartIcon,
  disabled,
  onKeyDown,
  onBlur,
  errors,
  inputRef,
}: Props) {
  const getMessage = (message: any): string => {
    if (typeof message === "string") return message;
    if (message && "message" in message) return message.message;
    return null;
  };

  const errorMessage = getMessage(errors[name]?.message);

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange } }) => (
        <Input
          ref={inputRef}
          className="mb-[2px] h-[38px] min-h-[38px]"
          StartIcon={StartIcon}
          label={label}
          name={name}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          errorMessage={errorMessage}
          onBlur={onBlur}
          disabled={disabled}
          isFullWidth
        />
      )}
    />
  );
}
